import React, { useMemo, useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Table } from "../../../Components/Table/Table";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { getAdminsList, deleteAdmin } from "../../../api/admin";
import toast from "react-hot-toast";

const Admin = () => {
    const navigate = useNavigate();

    const [search, setSearch] = useState("");
    const [admins, setAdmins] = useState([]);
    const [loading, setLoading] = useState(false);
    const role = localStorage.getItem("role");

   useEffect(() => {
    fetchAdmins();
    toast.success("Admin list loaded ✅");
}, []);

    const fetchAdmins = async () => {
        try {
            setLoading(true);
            const res = await getAdminsList();

            if (Array.isArray(res.data)) {
                setAdmins(res.data);
            } else if (Array.isArray(res.data.data)) {
                setAdmins(res.data.data);
            } else {
                setAdmins([]);
            }

        } catch (error) {
            toast.error("Failed to load admins ❌");
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = useCallback(async (id) => {
     toast(
        (t) => (
            <div>
                <p>Are you sure you want to delete?</p>
                <div style={{ marginTop: "8px", display: "flex", gap: "10px" }}>
                    <button
                        className="btn btn-sm btn-danger"
                        onClick={async () => {
                            toast.dismiss(t.id);
                            try {
                                await deleteAdmin(id);
                                toast.success("Deleted successfully 🗑️");
                                fetchAdmins();
                            } catch (error) {
                                toast.error(
                                    error.response?.data?.message || "Delete failed ❌"
                                );
                            }
                        }}
                    >
                        Yes
                    </button>

                    <button
                        className="btn btn-sm btn-secondary"
                        onClick={() => toast.dismiss(t.id)}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        ),
        { duration: 5000 }
    );
}, []); 

const columns = useMemo(
    () => [
        {
            Header: "S.No",
            Cell: ({ row }) => <span>{row.index + 1}</span>,
        },
        { Header: "Name", accessor: "username" },
        { Header: "Employee ID", accessor: "employeeId" },
        { Header: "Email", accessor: "email" },
        { Header: "Mobile", accessor: "phone" },
        {
            Header: "Role",
            accessor: "role",
            Cell: ({ value }) => (
                <span
                    className={`role-badge ${
                        value?.toLowerCase() === "super admin" ? "super" : "admin"
                    }`}
                >
                    {value}
                </span>
            ),
        },
        {
            Header: "Status",
            accessor: "status",
            Cell: ({ value }) => (
                <span
                    className={`status-badge ${
                        value === "Active" ? "active" : "blocked"
                    }`}
                >
                    {value || "Active"}
                </span>
            ),
        },
        {
            Header: "Actions",
            Cell: ({ row }) =>
                role === "superadmin" && (
                    <div className="action-icons">
                        <EditIcon
                            style={{ cursor: "pointer", marginRight: "10px" }}
                            onClick={() =>
                                navigate(`/admin/edit/${row.original._id}`)
                            }
                        />
                        <DeleteIcon
                            style={{ cursor: "pointer", color: "red" }}
                            onClick={() => handleDelete(row.original._id)}
                        />
                    </div>
                ),
        },
    ],
    [navigate, handleDelete, role] // ✅ FIXED
);
    // ✅ Search Filter
    const data = useMemo(() => {
        return admins.filter((admin) => {
            const searchText = search.toLowerCase();

            return (
                admin?.username?.toLowerCase().includes(searchText) ||
                admin?.email?.toLowerCase().includes(searchText) ||
                admin?.employeeId?.toLowerCase().includes(searchText)
            );
        });
    }, [admins, search]);


    return (
        <div className="container-admin">
            <div className="top-bar d-flex ac-jb">
                <h2 className="f2">Admin Management</h2>

                {role === "superadmin" && (
                    <button
                        className="add-btn"
                        onClick={() => navigate("/admin/add")}
                    >
                        <AddIcon /> Add Admin
                    </button>
                )}

            </div>

            <input
                type="text"
                placeholder="Search admin..."
                className="search-input"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
            />

            {loading ? (
                <p>Loading...</p>
            ) : (
                <Table columns={columns} data={data} />
            )}
        </div>
    );
};

export default Admin;
